import * as React from 'react'
import * as Container from "../../container/container";
import { StaticImage } from "gatsby-plugin-image";

const Novel = (key) => {
    return (
        <Container.Fullwidth key={key.toString() + 'slider'}>
            <Container.Novel id={key} sliderTitleId="nodelTitle">
                <div className="bg-grey">
                    <p>1919 Vilshofen an der Donau</p>
                    <h2>Beim alljährlichen Viehmarkt am Aschermittwoch in Vilshofen, <br/>5. März 1919</h2>
                    <StaticImage src="../../../../static/images/Vilshofen/Novel/Szene_1_Bild_1.png" placeholder="none"  alt=""/>
                </div>
                <StaticImage src="../../../../static/images/Vilshofen/Novel/Szene_1_Bild_2.png" placeholder="none"  alt=""/>
                <StaticImage src="../../../../static/images/Vilshofen/Novel/Szene_1_Bild_3.png" placeholder="none"  alt=""/>
                <div className="bg-grey">
                    <h2>Mittags bei der Versammlung des Bayerischen
                        Bauernbunds im Wieninger-Saal in Vilshofen
                    </h2>
                    <StaticImage src="../../../../static/images/Vilshofen/Novel/Szene_2_Bild_1.png" placeholder="none"  alt=""/>
                </div>
                <StaticImage src="../../../../static/images/Vilshofen/Novel/Szene_2_Bild_2.png" placeholder="none"  alt=""/>
            </Container.Novel>
        </Container.Fullwidth>
    )
}

export default Novel

